function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  width: 36,
  height: 36,
  rx: 5,
  fill: "#64B5F6"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18 9a9 9 0 100 18 9 9 0 000-18zm0 1.412a7.555 7.555 0 017.145 5.068.869.869 0 01-.665.554c-.498.11-1.163.138-2.243-.194-1.025-.305-1.966-.858-4.098-.97h-.277c-2.16.112-3.102.665-4.099.97a4.207 4.207 0 01-2.243.194.774.774 0 01-.665-.554A7.59 7.59 0 0118 10.412zm1.33 8.197a1.302 1.302 0 11-2.604 0 1.302 1.302 0 012.603 0zm-5.318 3.462a2.082 2.082 0 01-2.021.554 7.319 7.319 0 01-1.523-3.933c.11-.166.387-.304.941-.36.803-.083 1.634.083 2.382 1.191.748 1.108.581 2.132.221 2.548zm6.757 3.018a7.55 7.55 0 01-5.538 0 1.149 1.149 0 01-.332-.72c0-.914 1.384-1.661 3.101-1.661s3.102.747 3.102 1.661a1.023 1.023 0 01-.333.72zm3.268-2.464a2.082 2.082 0 01-2.022-.554c-.36-.416-.553-1.44.222-2.548s1.606-1.246 2.382-1.19c.553.055.83.166.941.36a7.319 7.319 0 01-1.523 3.932z",
  fill: "#E3F2FD"
});

function SvgTrip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgTrip;